<template>
  <div class="reviews">
    <div ref="result"></div>
    <swiper v-if="showSlider" id="swiper-wrapper" :options="swiperOption" :dir="$vs.rtl ? 'rtl' : 'ltr'" :key="$vs.rtl" >

      <swiper-slide v-if="item.rating > 3" v-for="(item,index) in resultData" :key="index">
       <customer-review :item="item" />
      </swiper-slide>
      <div class="swiper-button-prev pp-top" slot="button-prev"></div>
      <div class="swiper-button-next pp-top" slot="button-next"></div>
    </swiper>
  </div>
</template>

<script>
import {swiper, swiperSlide, directive} from 'vue-awesome-swiper'
import CustomerReview from './CustomerReview'

import StarRating from 'vue-star-rating'
import 'swiper/swiper-bundle.css'

export default {
  props: {
    place_id: {
      type: String
    },
    resultData: {
      type: Array
    }
  },
  components: {
    swiper,
    swiperSlide,
    StarRating,
    CustomerReview
  },
  directives: {
    swiper: directive
  },
  name: 'Reviews',
  data () {
    return {
      showSlider: false,
      swiperOption: {
        slidesPerView: 3,
        spaceBetween: (this.isMobile) ? 1 : 10,
        slidesPerGroup: 1,
        loop: true,
        loopFillGroupWithBlank: false,
        pagination: {
          el: '.swiper-pagination',
          clickable: true
        },
        navigation: {
          nextEl: '.swiper-button-next',
          prevEl: '.swiper-button-prev'
        }
      }
    }
  },
  computed: {
    isMobile () {
      return this.$store.state.api.isMobile
    }
  },
  methods: {
    ReviewsInit () {
      const self = this

      if (self.isMobile) {
        self.swiperOption.slidesPerView = 1
      }
      self.showSlider = true
      /*this.service.getDetails({placeId: this.place_id}, function (PlaceResult, PlacesServiceStatus) {
        // PlaceResult is an object
        // PlacesServiceStatus is a string
        self.resultData = PlaceResult.reviews
      })*/

    }
  },
  mounted () {
    this.ReviewsInit()
  }
}
</script>

<style lang="scss">
  .reviews {
    position: relative;
  }
  .pp-top {
    top: 50%;
    color: black;
  }
  .mobile .pp-top {
    top: 50%;
  }
  .pp-top:after {
    font-size: 24px;
  }
  .author_name {
    text-transform: capitalize;
  }
  .swiper-button-prev.pp-top {
    left:0;
  }
  .swiper-button-next.pp-top {
    right: 0;
  }
  .mobile .content-area__content {
    max-width: unset;
  }
  .reviews .swiper-container {
      overflow: hidden;
      padding: 1.2rem .5rem;
      margin: 0 1.8rem;
  }
  .swipe-image-wrapper {
     width: 100%;
  }
  .autocomplete-items {
    position: absolute;
    border: 1px solid #d4d4d4;
    border-bottom: none;
    border-top: none;
    z-index: 99;
    /*position the autocomplete items to be the same width as the container:*/
    top: 100%;
    left: 0;
    right: 0;
    background: white;
  }
  .autocomplete-items li {
    padding: 10px;
    cursor: pointer;
    background-color: #fff;
    border-bottom: 1px solid #c3c3c3;
  }
  .autocomplete-items li:hover {
    /*when hovering an item:*/
    background-color: #e9e9e9;
  }
  .autocomplete-active {
    /*when navigating through the items using the arrow keys:*/
    background-color: DodgerBlue !important;
    color: #ffffff;
  }
  .autocomplete {
    /*the container must be positioned relative:*/
    position: relative;
    display: inline-block;
  }
</style>
